import { DashBoardView } from "./dashboard";

export default {
  DashBoardView,
};
